import { Component, OnInit } from '@angular/core';
import { FeedbackType } from 'src/app/general-components/feedback/feedback-type';
import { FeedbackSettings } from 'src/app/general-components/feedback/feedback-settings';
import { Router } from '@angular/router';
import { ReturnFailure } from './return-failure';
import { ReturnFailuresService } from './return-failures.service';

@Component({
  selector: 'app-return-failures',
  templateUrl: './return-failures.component.html',
  styleUrls: ['./return-failures.component.scss'],
})
export class ReturnFailuresComponent implements OnInit {
  returnFailures: ReturnFailure[] = [];

  isLoading: boolean = false;
  showFeedback: boolean = false;

  feedbackSettings: FeedbackSettings = {
    identifier: '',
    show: false,
    type: FeedbackType.error,
    message: 'Er is iets misgegaan sorry',
    closeButton: false,
  };

  constructor(
    private returnFailuresService: ReturnFailuresService,
    private router: Router
  ) {}

  updateFeedback(type: FeedbackType, message: string, buttonText: string) {
    this.feedbackSettings.identifier = '';
    this.feedbackSettings.show = true;
    this.feedbackSettings.closeButton = false;
    this.feedbackSettings.buttonText = buttonText;

    this.feedbackSettings.type = type;
    this.feedbackSettings.message = message;
  }

  ngOnInit(): void {
    this.getReturnFailures();
  }

  getReturnFailures() {
    this.isLoading = true;
    this.returnFailuresService.getReturnFailures().subscribe({
      next: (returnFailures: ReturnFailure[]) => {
        this.returnFailures = returnFailures;
        this.isLoading = false;
      },
      error: (error: Error) => {
        this.updateFeedback(
          FeedbackType.error,
          'We konden de retourbevestigingen met fouten niet ophalen.',
          'Terug naar hoofdmenu'
        );
        this.isLoading = false;
        console.error(error);
      },
    });
  }

  returnHome() {
    void this.router.navigate(['home']);
  }
}
